import React, { useState } from "react";
import BackToTop from "../components/BackToTop";
import SearchBar from "../components/SearchBar";
import InfoCard from "../components/InfoCard";
const posts = [
    {
        name: "Increase Vitamin B12 Naturally",
        videoUrl: "https://www.youtube.com/embed/hfAzwS79PXE?si=E6QSpVbIW3JPAsEf",

        description:
            "How to Increase the level of Vitamin B12 naturally. How to treat Vitamin B12 deficiency. Best Vegetarian foods for vitamin B12. Natural Supplements for Vitamin B12. What are the symptoms of Vitamin B12 deficiency.",
        date: "2026-04-18",
        isNew: true
    },
    {
        name: "Green Gold : The Neem Farmacy",
        videoUrl: "https://www.youtube.com/embed/zXgChiaVlGA?si=nm62uSCkuxZqznCi",

        description:
            "Benefits of neem for skin, hair and overall health. How to use neem for acne, dandruff, and other common issues. The science behind neem's powerful properties and how it can be a natural solution for many health concerns. Its a 'Farm'acy because neem is a versatile plant that can be used in various forms - from leaves to oil to bark - to promote wellness and beauty. Discover the secrets of this green gold and how it can transform your health naturally. Discover ways to incorporate neem into your daily routine for a healthier lifestyle and get rid of common ailments.",
        date: "2026-03-13",
        isNew: false
    },
    {
        name: "10 World’s Best Protein Sources Ranked Low to High",
        videoUrl: "https://www.youtube.com/embed/FDEgZzJlY7s?si=feftb6UOtZhpEHrp",

        description:
            "What if everything you’ve been told about protein is incomplete? In this video, we rank 10 powerful plant-based protein sources from lowest to highest starting at just 7g and going all the way up to an unexpected source with over 24g per serving. Most of these foods are simple, affordable, and already part of traditional diets - yet hardly talked about in modern times. But this isn’t just about a list. Watch till the end - the #1 source surprises almost everyone.",
        date: "2026-02-09",
        isNew: false
    },
    {
        name: "Why & How Celebrities Follow Ayurveda ",
        videoUrl: "https://www.youtube.com/embed/Lahz0UK1Rw0?si=ZPtzbCDj1gJGE7m-",

        description:
            "Celebrities are increasingly turning to Ayurveda because it offers sustainable, long-term health, not quick fixes. Their lifestyles involve irregular schedules, high stress, frequent travel, intense workouts, and constant public pressure. Ayurveda focuses on balancing digestion, sleep, stress, and hormones, which directly addresses these challenges. Unlike crash diets or extreme fitness trends, Ayurveda emphasizes routine, personalized diet, and mental calm, helping celebrities maintain energy, skin health, weight, and recovery without burnout. Practices like early sleep, warm food, seasonal eating, yoga, and meditation improve gut health and stress regulation, which reflect quickly on appearance—clear skin, stable weight, and better mood.Another reason is preventive care. Ayurveda aims to correct imbalances before disease appears, which is valuable for people who cannot afford long downtime due to illness. As awareness grows that true fitness comes from internal regulation, celebrities adopt Ayurveda not as tradition, but as a high-performance health system.",
        date: "2026-01-23",
        isNew: false
    },
    {
        name: "National Ayush Mission - The future of healthcare",
        videoUrl: "https://www.youtube.com/embed/o4ZJAfT7F0U?si=ogDRZzjpvw5fWIT_",

        description:
            "The National Ayush Mission (NAM) aims to provide accessible Ayush healthcare services across India by strengthening and improving the existing healthcare infrastructure. With the establishment of Ayush Health and Wellness Centres, this initiative focuses on creating a holistic wellness model that prioritizes preventive and promotive care based on Ayush principles, reducing disease burden and out-of-pocket healthcare expenditure.",
        date: "2026-01-23",
        isNew: false
    },
    {
        name: "The Queen of Herbs! | By Dr. Bimal Chhajer",
        videoUrl: "https://www.youtube.com/embed/Yh1iMHA9Fb4?si=gSZ2QDvup3k71xBA",

        description:
            "Tulsi is called the “Queen of Herbs” because it supports the body at every level—physical, mental, and subtle.In Ayurveda, Tulsi is classified as a rasayana, meaning it promotes longevity and resilience. It strengthens the immune system, helping the body fight infections naturally. Tulsi supports the respiratory system, easing cough, cold, and congestion, which is why it is widely used in seasonal illnesses. It also improves digestion and metabolism, reducing gas and toxin buildup (ama).Tulsi is a powerful adaptogen, meaning it helps the body adapt to stress. It balances stress hormones, calms the nervous system, and supports mental clarity. This mind–body regulation is rare in a single herb. Tulsi also has anti-inflammatory, antibacterial, antiviral, and antioxidant properties, protecting organs like the liver, lungs, and heart.Spiritually, Tulsi holds a unique place in Indian tradition. It is believed to purify the environment, and its presence is said to promote sattva—clarity, balance, and calmness. Unlike many herbs that act only on one system, Tulsi works holistically, correcting imbalances rather than suppressing symptoms.Because it is safe for daily use, deeply nourishing, and broadly protective, Ayurveda honors Tulsi as the Queen of Herbs—an herb that supports life itself. ",
        date: "2026-01-19",
        isNew: false
    },
    {
        name: "How to cure Rheumatoid Arthritis",
        videoUrl: "https://www.youtube.com/embed/vo6-EINYeiY?si=BhC42A8Z-F_o_fiX",

        description:
            "An in-depth video on Rheumatoid Arthritis to help you get a complete understanding of the condition from symptoms, causes, treatment to yogic management tips. Help us reach out to many people to help them better manage this condition through yoga. We aim to promote well-being and make this world a better place to live in. Thank you! ",
        date: "2026-01-08",
        isNew: false
    },
    {
        name: " Crohn's Bowel Disease Treatment | Diet & Panchakarma Benefits",
        videoUrl: "https://www.youtube.com/embed/h4KdSLuQXKc?si=cb12aGCGIRuFK44E",

        description:
            "A Crohn’s disease patient was told to eat fruits to heals by eating fruits. A man with haemoglobin 7 reaches 13 in eleven days with just one juice. A woman with angiosarcoma whose wound had worms starts recovering in twelve days. Have you ever wondered why so many people suffer for years, even after taking medicines on time? Why do treatments keep increasing, but relief keeps decreasing? Why does the body feel weaker even when reports say everything is fine. Feeling drained every day Losing strength after every medicine. Living with the fear of what will happen next Watching savings vanish and health still not improving Seeing loved ones suffer without answers. Acharya Manish Ji says, 'Until you give your body rest and cleansing, it will never give you peace.' Ayurveda says that when digestion weakens, toxins accumulate, and every organ starts losing its power. When diet timing, sunlight, fasting and lifestyle fall out of rhythm, even the strongest body breaks. But the moment the body gets space to repair, healing begins faster than anyone expects. This will make you question everything you believed about your illness and your treatment. Watch it once and listen with your heart Your body has been trying to talk to you for years",
        date: "2026-01-07",
        isNew: false
    },
    {
        name: "Homeopathy medicine for ulcerative colitis",
        videoUrl: "https://www.youtube.com/embed/uPthpflnG6E?si=PMPK1LfMAnlEkSlv",

        description:
            "Homeopathic medicine is often chosen by people with ulcerative colitis because it follows a holistic and individualized approach, rather than treating everyone with the same medicine. Homeopathy aims to support the body’s natural healing response by understanding a person’s physical symptoms, emotional state, stress levels, digestion, lifestyle, and overall constitution. Since ulcerative colitis is closely linked to the gut–mind connection, many believe this personalized method helps in better long-term balance. Another reason people prefer homeopathy is that the medicines are considered gentle and non-toxic, making them suitable for long-term use without fear of dependency or harsh side effects. Instead of only suppressing symptoms like pain, diarrhea, or bleeding, homeopathy focuses on improving overall well-being, immunity, and internal harmony. For many patients, it becomes a natural, supportive path toward managing symptoms, improving quality of life, and maintaining remission alongside healthy lifestyle practices.",
        date: "2025-12-26",
        isNew: false
    },
    {
        name: "Curry Leaves - Benefits & How to take?",
        videoUrl: "https://www.youtube.com/embed/beOmL1KJ4GI?si=6sJl3sSGLQ3HHvqA",

        description:
            "Discover the incredible health benefits of curry leaves for weight loss, hair Loss and also the various ways you can incorporate this beneficial herb in your daily diet and beauty remedies to stay healthy and fit. Please share this amazing informative video with friends and family about the powerful benefits of curry leaves. Together let us aim to promote wellbeing and make this world a better place to live in.",
        date: "2025-12-15",
        isNew: false
    },
    {
        name: "Superfoods for Gut Health",
        videoUrl: "https://www.youtube.com/embed/o1aVVg7Qfgc?si=uiIyN4tpwEjbjbKH",

        description:
            "What if your gut has been trying to save you for years, but you never learned how to build the good bacteria that keep you alive. Bloating, gas and heaviness make you feel drained every single day. Spicy food, stress and late-night meals keep disturbing your microbiome.",
        date: "2025-12-05",
        isNew: false
    },
    {
        name: "The Best Joint pain relief",
        videoUrl: "https://www.youtube.com/embed/nR96ytH9o9s?si=bqImTn2TQD7yIEyP",

        description:
            "Ayurveda says pain is not the problem, toxins are. Learn how to detoxify naturally using Ayurvedic principles and remedies for lasting relief from chronic pain.",
        date: "2025-11-22",
        isNew: false
    },
    {
        name: "What is Homeopathy? Explained!",
        videoUrl: "https://www.youtube.com/embed/JZ35_hUZKRA?si=LT3kRZP28-bKpV9_",
        imagelink: "https://en.wikipedia.org/wiki/Homeopathy",

        description: "A short explainer on the principles of homeopathy, its history, and how it is used today.",
        // no fullArticleLink for this post
        date: "2025-11-18",
        isNew: false
    },
    {
        name: "Naturopathy | Healthy living tips",
        videoUrl: "https://www.youtube.com/embed/QmNhFZz5tk4?si=n1nyFh14V2eKpq2W",
        description:
            "Elevate your well-being with 5 Naturopathy Hacks for Healthy Living! Explore a treasure trove of natural remedies and holistic practices designed to nurture your body, mind, and spirit.",
        date: "2025-11-13",
        isNew: false
    },
    {
        name: "What is Magnetotherapy?",
        videoUrl: "https://www.youtube.com/embed/PYjNaR6nOIE?si=jHDaIZMwHJCExBJ3",

        description:
            "Magnetotherapy is an advanced non-surgical solution for musculoskeletal injuries and degeneration. It involves the use of specifically calibrated electromagnetic fields to induce biochemical changes at the cellular level, stimulating natural healing mechanisms. Unlike ordinary magnetic devices, magnetotherapy devices are based on sound medical concepts and research.",
        // no fullArticleLink for this post
        date: "2025-11-10",
        isNew: false
    }
];

export default function Feed({ turnOffAudio }) {
    const [search, setSearch] = useState("");

    const filtered = posts?.filter(
        post =>
            post.name.toLowerCase().includes(search.toLowerCase()) ||
            (post.text && post.text.toLowerCase().includes(search.toLowerCase())) ||
            (post.description && post.description.toLowerCase().includes(search.toLowerCase()))
    );

    return (
        <div
            style={{
                maxWidth: 800,
                margin: "0 auto",
                padding: 24,
                fontFamily: "Segoe UI,Roboto,Arial,sans-serif",
                background: "linear-gradient(-45deg, #f8fffc 0%, #e0f7fa 50%, #d0f8e8 100%)",
                minHeight: "100vh"
            }}
        >
            <SearchBar
                value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="Search articles or videos..."
            />
            {filtered.length === 0 && (
                <div style={{ textAlign: "center", color: "#888", fontSize: 20 }}>No results found.</div>
            )}
            {filtered.map((post, idx) => (
                <InfoCard turnOffAudio={turnOffAudio} key={post.id} {...post} section="feed" />
            ))}
            <BackToTop />
        </div>
    );
}
